<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import { handleSortItem } from 'utils/utils';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';
  import { checkStrNA, numToPercentStr } from 'utils/string';
  import { divideNumber, divideNumberPercent } from 'utils/number';
  import checkboxWatcher from '@/mixins/checkboxWatcher';
  import { getAffPaymentEntityReport } from 'api/billing/affiliate/affEntityReport';

  export default {
    name: 'AffEntityReport',
    components: {
      BaseListLayout,
      Pagination,
    },
    mixins: [myMixin, billingEnumMixins, financeInfoMixins, checkboxWatcher],
    data() {
      return {
        total: 0,
        listLoading: false,
        dataList: [],
        groupItemCheck: {
          affCompanyPlatformCheck: null,
          paymentTimeCheck: null,
          affEntityCheck: null,
          hyperTapEntityCheck: null,
          paymentStatusCheck: null,
        },
        filter: {
          page: 1,
          pageSize: 10,
          affCompanyPlatformList: [],
          affEntityIdList: [],
          hyperTapEntityId: null,
          paymentStatus: null,
          groupItems: [],
          recordDateRange: [],
          paymentTimeRange: [],
          sortItems: [],
        },
      };
    },
    mounted() {
      this.handleSearch();
      this.checkboxConfig.targetArray = this.filter.groupItems;
      this.checkboxConfig.searchFunc = this.handleSearch;
    },
    methods: {
      numToPercentStr,
      divideNumberPercent,
      divideNumber,
      checkStrNA,
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },
      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getAffPaymentEntityReport(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Aff Billing Entity Report'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="180px" ref="searchForm">
        <el-form-item label="Date">
          <el-date-picker
            v-model="filter.recordDateRange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="monthrange"
            clearable
            style="width:260px;"
            align="right"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="monthPickerOptions"
          />
        </el-form-item>
        <el-form-item label="Payment Date">
          <div class="row-multi-item">
            <el-date-picker
              v-model="filter.paymentTimeRange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              clearable
              style="width:260px;"
              align="right"
              unlink-panels
              range-separator="to"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="monthPickerOptions"
            />
            <el-checkbox v-model="groupItemCheck.paymentTimeCheck" name="payment_time" />
          </div>
        </el-form-item>
        <el-form-item label="Aff Company Platform">
          <div class="row-multi-item">
            <el-select
              v-model="filter.affCompanyPlatformList"
              filterable
              multiple
              clearable
              placeholder="please select"
              @change="handleCompanyPlatformChange(filter.affCompanyPlatformList)"
            >
              <el-option
                v-for="item in companyPlatformList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.affCompanyPlatformCheck"
              name="advertiser_company_platform"
            />
          </div>
        </el-form-item>
        <el-form-item label="Aff Entity">
          <div class="row-multi-item">
            <el-select
              v-model="filter.affEntityIdList"
              ref="companyEntityOptions"
              filterable
              multiple
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in specificCompanyEntity"
                :key="item.id"
                :label="item.companyEntity"
                :value="item.id"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.affEntityCheck" name="aff_entity" />
          </div>
        </el-form-item>
        <el-form-item label="HyperTap Entity">
          <div class="row-multi-item">
            <el-select
              v-model="filter.hyperTapEntityId"
              filterable
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in hyperTapCompanyEntities"
                :key="item.bfiId"
                :label="item.companyEntityAlias"
                :value="item.bfiId"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.hyperTapEntityCheck" name="hyper_tap_entity" />
          </div>
        </el-form-item>
        <el-form-item label="Payment Status">
          <div class="row-multi-item">
            <el-select
              v-model="filter.paymentStatus"
              filterable
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in affFullPaymentStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.paymentStatusCheck" name="payment_status" />
          </div>
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch(1)">Search</el-button>
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        :data="dataList"
        highlight-current-row
        @sort-change="handleSort"
      >
        <el-table-column
          label="Date"
          prop="recordDate"
          fixed="left"
          align="center"
          width="120"
          key="recordStartDate"
        />

        <el-table-column
          label="Aff Company Platform"
          prop="affCompanyPlatform"
          align="center"
          width="180"
          show-overflow-tooltip
          key="affCompanyPlatform"
        />
        <el-table-column
          label="Aff Entity"
          prop="affEntity"
          align="center"
          show-overflow-tooltip
          width="170"
          key="affEntity"
        />

        <el-table-column
          label="HyperTap Entity"
          prop="hyperTapEntity"
          align="center"
          key="hyperTapEntity"
          width="160"
        >
          <template #default="scope">
            {{ getHyperTapCompanyAlias(scope.row.hyperTapEntity) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Conversion"
          prop="affiliateConversion"
          align="center"
          key="affiliateConversion"
          width="160"
          sortable="custom"
        />
        <el-table-column
          label="Aff Revenue"
          prop="affiliateRevenue"
          align="center"
          key="affiliateRevenue"
          width="140"
          sortable="custom"
        />
        <el-table-column
          label="Aff Deduction Amount"
          prop="affiliateDeductionAmount"
          align="center"
          key="affiliateDeductionAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="Aff Cover Amount"
          prop="affiliateCoverAmount"
          align="center"
          key="affiliateCoverAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="Aff Confirmed Amount"
          prop="affiliateConfirmedAmount"
          align="center"
          key="affiliateConfirmedAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="Aff Confirmed Amount Rate"
          align="center"
          key="affConfirmedRevenueSettlementRate"
          width="250"
        >
          <template #default="scope">
            {{ numToPercentStr(scope.row.affConfirmedRevenueSettlementRate) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Hedge Amount"
          prop="affiliateHedgeAmount"
          align="center"
          key="affiliateHedgeAmount"
          width="180"
          sortable="custom"
        />
        <el-table-column
          label="Aff Actual Amount"
          prop="affiliateActualAmount"
          align="center"
          key="affiliateActualAmount"
          width="180"
          sortable="custom"
        />
        <el-table-column
          label="Finance payment amount"
          prop="financePaymentAmount"
          align="center"
          key="financePaymentAmount"
          width="220"
          sortable="financePaymentAmount"
        />
        <el-table-column
          label="Aff Confirmed Status"
          align="center"
          key="affReconciliationProgress"
          prop="affReconciliationProgress"
          width="280"
        >
          <template #default="scope">
            {{ getEnumLabel(reconciliationProgressList, scope.row.affReconciliationProgress) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Payment Date"
          prop="paymentTime"
          align="center"
          key="paymentTime"
          width="180"
        />
        <el-table-column
          label="Payment Status"
          prop="affPaymentStatus"
          align="center"
          key="affPaymentStatus"
          width="180"
        >
          <template #default="scope">
            {{ getEnumLabel(affFullPaymentStatusList, scope.row.affPaymentStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Payment Confirmed Amount Rate"
          align="center"
          key="financePaymentAmountSettlementRate"
          width="250"
        >
          <template #default="scope">
            {{ numToPercentStr(scope.row.financePaymentAmountSettlementRate) }}
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss"></style>
